import Tr from 'translations/Translations';

const createItem = (label, value) => ({
	label,
	value
})

export const MEASURE_UNIT = {
	DAY: 0,
	MONTH: 1,
	WEEKS: 2,
	YEARS: 3,
}

export const MEASURE_UNIT_LABEL = {
	[MEASURE_UNIT.DAY]: Tr('days'),
	[MEASURE_UNIT.MONTH]: Tr('months'),
	[MEASURE_UNIT.WEEKS]: Tr('weeks'),
	[MEASURE_UNIT.YEARS]: Tr('years'),
}

const values = Object.keys(MEASURE_UNIT_LABEL).map( item => 
	createItem(MEASURE_UNIT_LABEL[item], item)
)

export default values;